import { Context, createContext } from 'react';
import { IMainContext } from '../interfaces';

export const mainDefaultState: IMainContext = {
    session: null,
    source: null,
    locale: null,
    project: null,
    settings: null,
    paymentId: null,
    jwt: null,
    showCaptcha: false,
    failedAttemptCenter: (): void => {},
    loader: false,
    toggleLoader: (): void => {},
    modalContent: null,
    setModalContent: (): void => {},
    setSession: (): void => {},
    setSource: (): void => {},
    setLocale: (): void => {},
    setProject: (): void => {},
    setPaymentId: (): void => {},
    setJwt: (): void => {},
    userAuthData: null,
    setUserAuth: (): void => {},
    paymentPopupData: null,
    setPaymentPopupData: (): void => {},
};

export const MainContext: Context<IMainContext> = createContext<IMainContext>(mainDefaultState);
